<template>
  <v-container fluid>
    <v-row>
      <LayoutNavbar />
    </v-row>
    <v-row v-if='isAdmin'>
      <LayoutAdminBar />
    </v-row>
    <v-row>
      <v-col class='pa-0' offset-sm='1' sm='10'>
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LayoutNavbar from '@/components/MainLayout/LayoutNavbar';
import LayoutAdminBar from '@/components/MainLayout/LayoutAdminBar';

export default {
  components: { LayoutAdminBar, LayoutNavbar },

  computed: {
    isAdmin() {
      return this.$store.getters.getIsViewAdminPanel;
    },
  },
};
</script>